import "./CenteredMessage.css"

const CenteredMessage = ({ message }) => {
    return (
        <div className="centered-message-container">
            <h1 className="centered-message-title">{message}</h1>
        </div>
    )
};

export default CenteredMessage;